import validators from './validators';

import FormsyForm, { addValidationRule } from 'formsy-react';


validators.map((validator, name) => {
  addValidationRule(name, validator);
});

addValidationRule('isNotWhitespaceOnly', (values, value) => {
  return value && value.trim().length > 0;
});


export default FormsyForm;

export * from '../form/inputs';
